<template>
  <div
    :class="[{ 'fixed inset-0 flex items-center justify-center flex-col mb-100': fullPage }]"
  >
    <div class="circle-progress">
      <svg
        class="circle-progress__svg"
        viewBox="-2 -2 108 108"
        :width="circleSize"
        :height="circleSize"
      >
        <circle
          class="circle-progress--circle circle-progress-fill-line--back"
          :r="radius"
          cx="52"
          cy="52"
        />
        <circle
          ref="fillingCircle"
          :class="fillCircleClasses"
          :style="fillingCircleStyles"
          :r="radius"
          cx="52"
          cy="52"
          transform="rotate(270 52 52)"
        />
      </svg>

      <div class="circle-progress--content">
        <img
          src="@/assets/icons/heart.svg"
          :style="`height: ${heartSize};`"
          class="mt-2"
          alt="thank-you-heart"
        >
      </div>
    </div>
    <!--    <div class="thank-you-message text-xl mt-10">-->
    <!--      {{ t('donation.messages.thanks') }}-->
    <!--    </div>-->
  </div>
</template>

<script lang="ts">
import {ref, defineComponent, reactive} from 'vue';
import {useI18n} from "vue-i18n";
import { useDonationSessionStore } from "../../stores/donationSession";

export default defineComponent({
  name: "ThankYouAnimation",
  props: {
    fullPage: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "large"
    }
  },

  setup(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    props = reactive(props);
    const {t} = useI18n();
    const donationSessionStore = useDonationSessionStore();

    return {
      donationSessionStore,
      fillingCircle: ref(null),
      radius: ref(48),
      t
    };
  },
  computed: {
    fillCircleClasses() {
      return {
        "circle-progress--circle": true,
        "circle-progress-fill--value": !this.noProgress,
        "circle-progress-fill-line": true
      };
    },
    noProgress() {
      return false;
    },
    circleSize() {
      return this.size === "large" ? 200 : 100;
    },
    heartSize() {
      return this.size === "large" ? "100px" : "50px";
    },

    dashArray() {
      return (this.radius * Math.PI * 2);
    },
    dashOffset() {
      return this.dashArray - this.dashArray;
    },
    fillingCircleStyles() {
      return {
        'strokeDashoffset': this.dashOffset,
        'strokeDasharray': this.dashArray,
      };
    }
  },
  mounted() {
    // After the animation finishes, redirect to the landing page
    if (this.fullPage) {
      setTimeout(() => {
        const userSignedIn = this.donationSessionStore.donationSession.userAuthenticated;
        if (userSignedIn) {
          const org = this.$route.params.org || this.donationSessionStore.organizationId;
          window.location.href = `/${org}/donor/dashboard/overview?donated=true`;
        } else {
          this.$router.push({ name: 'landing' });
        }
      }, 3000);
    }
  },
});
</script>
<style lang="scss" scoped>
@keyframes filling {
  from {
    stroke-dashoffset: v-bind("dashArray");
  }
  to {
    stroke-dashoffset: v-bind("dashOffset");
  }
}

@keyframes spinning {
  0% {
    stroke-dashoffset: 0;
  }
  66% {
    stroke-dashoffset: v-bind("dashArray");;
  }
}

.circle-progress-fill--value {
  animation-name: filling;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  transition: 0.5s all;
}

.circle-progress-fill--no-value {
  animation-name: spinning;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite; /* Run the animation continuously */
  transition: 0.5s all;
}

.circle-progress--circle {
  fill: transparent;
  stroke-width: 6px;
}

.circle-progress-fill-line--back {
  stroke: transparent;
  stroke-dashoffset: 0;
}

.circle-progress {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}

.circle-progress-fill-line {
  stroke: #D4323F;
}

.circle-progress--content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

</style>
